"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["fill"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*eslint-disable */
var _default = function _default(_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#B2ADA6' : _ref$fill,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("g", {
    "data-testid": "cloudy-icon"
  }, /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M7.77007 9.33005C7.50006 9.33005 7.14006 9.24005 6.78005 9.24005C4.71002 9.24005 3 10.9501 3 13.0201C3 15.0901 4.71002 16.8002 6.78005 16.8002H12.2701V6C10.2001 6.09 8.40008 7.44002 7.77007 9.33005Z",
    fill: fill
  })), /*#__PURE__*/_react["default"].createElement("path", _extends({}, rest, {
    d: "M21 13.3801C21 11.5801 19.56 10.1401 17.76 10.1401C17.58 10.1401 17.4 10.1401 17.22 10.2301C16.95 7.80003 14.8799 6 12.3599 6H12.2699V16.8002H17.76C19.47 16.6201 21 15.1801 21 13.3801Z",
    fill: fill
  })));
};

exports["default"] = _default;